// extracted by mini-css-extract-plugin
export default {"Chunk":"PlateChunk_Chunk__AJzYY"};